import { consentAllows } from './consent';

function trackAddToBag({
  productId, price, imageUrl, name, url,
}) {
  if (!window.geq || !consentAllows('email_pixels')) { return; }

  window.geq.addToCart({
    productId,
    price,
    quantity: 1,
    imageUrl,
    name,
    url,
  });
}

const retentionPixel = {
  trackAddToBag,
};

export default retentionPixel;
